import React, { useEffect,useState } from 'react'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare , faGear , faCirclePlus , faCircleArrowLeft , faMoneyBills} from '@fortawesome/free-solid-svg-icons';

import useWeb3 from '../../hooks/useWeb3'; 
import Header from '../../components/Header'; 
import toast, { Toaster } from 'react-hot-toast';
import styled from 'styled-components';

import {UserCreatedTokensList , UserCreatedNumberofTokens} from '../../hooks/useContractFactory';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import MenuButtons from '../../components/MenuButtons';


function TokenManage() {

    document.title = "Altcoinator | Token Manage";
     const {account} = useWallet();
 
     const Load = styled.div`
     width: 45px;
     height: 45px;
     border-radius: 50%;
     border: 6px solid #0000;
     border-right-color: #86FF00;
     position: relative;
     animation: s4 1s infinite linear;

     &:after {
        content: "";
    position: absolute;
    inset:-4px;
    border-radius: 50%;
    border:inherit;
    animation:inherit;
    animation-duration: 2s;
    animation-duration: 4s;
      }

      @keyframes s4 {
        100% {transform: rotate(1turn)}
      }
       `;

       const list = UserCreatedTokensList();
       const number = UserCreatedNumberofTokens();

       const sortedData = list.sort((a, b) => b.id - a.id);

 
     return ( 
     <>
    <div id="wrapper">
      <Header />
      
      <section className="tf-section tf-wallet" >
        <div style={{maxWidth:"760px"}} className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="wallet-form">
               <MenuButtons/>
                <hr/>
                <h4>Token Manage</h4>
                <hr/>
                <div className="choose-network flat-tabs">
                    <h6>Your Created Tokens</h6>
                     <div className='row'>
                     <div className="col-md-12">
                        <div className="tokenomics-wrapper aos-init aos-animate" data-aos="fade-up"  >
                            {number == 0 ? (<div className='alert alert-danger'>You have not created any tokens.</div>) : list.length == 0 ? (<center><Load/>Loading...</center>) : sortedData.map((e,index)=>{
                                return(<>
                                    <div key={index} className="box">
                                     
                                        <div className="td td2">
                                        <p>Name</p>
                                        <p>{e.name}</p>
                                        </div>
                                        <div className="td td3">
                                        <p>Symbol</p>
                                        <p>{e.symbol}</p>
                                        </div>
                                        <div className="td td4">
                                        <p>Decimal</p>
                                        <p>{e.decimal}</p>
                                        </div>
                                        <div className="td td5">
                                        <p>Supply</p>
                                        <p>{(e.totalsupply/10**e.decimal).toLocaleString()}</p>
                                        </div>
                                        <div className="td td5">
                                        <p></p>
                                        <p><Link type="submit" class="tf-button style2 w-100" to={"edit/" + e.contract}><FontAwesomeIcon icon={faPenToSquare} /></Link></p>
                                        </div>
                                    </div>
                                </>);
                            })}
                            
                            
                        </div>
                    </div>
                     </div>
                  </div>
                    <div className="bottom">
                         
                    </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
  </> ); 

} 

export default TokenManage;